import React from 'react'
import { Users, Briefcase, FileText, DollarSign } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Progress } from '@/components/ui/progress'
import type { JobberSyncStats as JobberSyncStatsType } from '@/features/jobber/types'

interface JobberSyncStatsProps {
  stats: JobberSyncStatsType
}

export function JobberSyncStats({ stats }: JobberSyncStatsProps) {
  const getSyncProgress = (current: number, total: number) => {
    if (total === 0) return 0
    return Math.round((current / total) * 100)
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatsCard
        title="Customers"
        icon={<Users className="w-6 h-6 text-chart-4" />}
        synced={stats.customers.synced}
        total={stats.customers.total}
        colorClass="bg-chart-4/10"
        progress={getSyncProgress(stats.customers.synced, stats.customers.total)}
      />
      <StatsCard
        title="Jobs"
        icon={<Briefcase className="w-6 h-6 text-chart-5" />}
        synced={stats.jobs.synced}
        total={stats.jobs.total}
        colorClass="bg-chart-5/10"
        progress={getSyncProgress(stats.jobs.synced, stats.jobs.total)}
      />
      <StatsCard
        title="Invoices"
        icon={<FileText className="w-6 h-6 text-accent" />}
        synced={stats.invoices.synced}
        total={stats.invoices.total}
        colorClass="bg-accent/10"
        progress={getSyncProgress(stats.invoices.synced, stats.invoices.total)}
      />
      <StatsCard
        title="Estimates"
        icon={<DollarSign className="w-6 h-6 text-accent" />}
        synced={stats.estimates.synced}
        total={stats.estimates.total}
        colorClass="bg-accent/10"
        progress={getSyncProgress(stats.estimates.synced, stats.estimates.total)}
      />
    </div>
  )
}

function StatsCard({ title, icon, synced, total, colorClass, progress }: any) {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="text-2xl font-bold">{synced.toLocaleString()}</p>
            <p className="text-xs text-muted-foreground mt-1">
              of {total.toLocaleString()} total
            </p>
          </div>
          <div className={`${colorClass} p-3 rounded-full`}>
            {icon}
          </div>
        </div>
        <div className="mt-4">
          <Progress value={progress} className="h-2" />
          <p className="text-xs text-muted-foreground mt-2">
            {progress}% synced
          </p>
        </div>
      </CardContent>
    </Card>
  )
}

